export default "__VITE_ASSET__CpbzNBf8__"